import moment from 'moment';

import { DAYS_FOR_OVERDUE } from './timesheet-constants';

function isOverdue(jobEndTime) {
  const becomesOverdue = moment(jobEndTime).add(DAYS_FOR_OVERDUE, 'days');
  const now = moment();
  return becomesOverdue.isBefore(now);
}


function getActualStartAndEndTimes(times, time) {
  const { start, end } = times;
  let actualStartTime;
  let actualEndTime;
  if (start) {
    actualStartTime = moment(start.value).format('HH:mm');
  }

  if (end) {
    actualEndTime = moment(end.value).format('HH:mm');
  }
  if (time === 'start') {
    return actualStartTime;
  }
  return actualEndTime;


}

export {
  isOverdue,
  getActualStartAndEndTimes,
};


export function hasRecordedSubmission(timesheets, timesheetKey) {
  if (!timesheetKey || timesheets.messagesTimesheetKey !== timesheetKey) return false;
  const submissionTitles = ['timesheet submission', 'timesheet submitted', 'timesheet submitted by admin'];
  return timesheets.messages.some(message => submissionTitles.includes((message.title || '').trim().toLowerCase()));
}

// Presence depends on the submission format, not the timesheet's lock status.
export function hasSubmissionDetails(booking, timesheetTypeKey) {
  if (timesheetTypeKey === 'start-end') return !!(booking.submittedStartTime && booking.submittedEndTime);
  if (timesheetTypeKey === 'on-site-off-site') return typeof booking.submittedOnSiteTime === 'number' && typeof booking.submittedOffSiteTime === 'number';
  if (timesheetTypeKey === 'start-end-multi') return Array.isArray(booking.submittedMultiTimes) && booking.submittedMultiTimes.length > 0;
  return false;
}
